import settings2Fill from '@iconify/icons-eva/settings-2-fill';
import { PATH_DASHBOARD, PATH_GENERAL } from './routes/paths';
import type { UserMenuOptions } from './@types/layouts';
import type { SelectOption } from './@types/common';
import { currentEnv } from './config';
import { ScheduleFactoryOption } from './@types/schedule';

// ----------------------------------------------------------------------

export const INITIAL_PATH = PATH_GENERAL.root;

export const LINK_MANAGE_USER: string =
  currentEnv === 'production'
    ? 'https://portal-server.datainsight.toyota-tsusho.com/web/management/user'
    : currentEnv === 'staging'
    ? 'https://portal-stg-server.datainsight-qas.toyota-tsusho.com/web/management/user'
    : 'https://datainsight-portal-server-development.toyotsu-digital.com/web/management/user';
export const LINK_MANAGE_ROLE: string =
  currentEnv === 'production'
    ? 'https://portal-server.datainsight.toyota-tsusho.com/web/management/role'
    : currentEnv === 'staging'
    ? 'https://portal-stg-server.datainsight-qas.toyota-tsusho.com/web/management/role'
    : 'https://datainsight-portal-server-development.toyotsu-digital.com/web/management/role';
export const LINK_ALLOCATE_ROLE: string =
  currentEnv === 'production'
    ? 'https://portal-server.datainsight.toyota-tsusho.com/web/management/apply'
    : currentEnv === 'staging'
    ? 'https://portal-stg-server.datainsight-qas.toyota-tsusho.com/web/management/apply'
    : 'https://datainsight-portal-server-development.toyotsu-digital.com/web/management/apply';

export const USER_MENU_OPTIONS: UserMenuOptions = [{ label: 'Settings', icon: settings2Fill, linkTo: PATH_DASHBOARD.account }];

export const AGGRID_ROWS_PER_PAGE: SelectOption[] = [
  { value: 10, label: '10 rows/page' },
  { value: 20, label: '20 rows/page' },
  { value: 30, label: '30 rows/page' },
];

export const TOOLTIP_SHOW_DELAY: number = 0;

export const USER_ROLES = {
  FLOUR_ADMIN: 'flour-admin',
  FLOUR_CUSTOMER: 'flour-customer',
  FLOUR_TOYOTSU: 'flour-toyotsu',
  FLOUR_MAKER: 'flour-maker',
  FLOUR_LOGISTICS: 'flour-logistics',
  FLOUR_SUPPLIER: 'flour-supplier',
} as const;

export const ORDER_STATUS = {
  ORDER_PREPARING: 'ORDER_PREPARING',
  SHIWO_TTC_ORDER_CONFIRMED: 'SHIWO_TTC_ORDER_CONFIRMED',
  TTC_SHOWA_ORDER_CONFIRMED: 'TTC_SHOWA_ORDER_CONFIRMED',
  ORDER_RECEIVED_BY_SHOWA: 'ORDER_RECEIVED_BY_SHOWA',
} as const;
export const ORDER_STEPS: SelectOption[] = [
  { value: ORDER_STATUS.ORDER_PREPARING, label: 'Order preparering' },
  { value: ORDER_STATUS.SHIWO_TTC_ORDER_CONFIRMED, label: 'SHIWO→TTC Order confirmed' },
  { value: ORDER_STATUS.TTC_SHOWA_ORDER_CONFIRMED, label: 'TTC→Showa Order confirmed' },
  { value: ORDER_STATUS.ORDER_RECEIVED_BY_SHOWA, label: 'Order received by Showa' },
];

export const DELIVERY_STATUS = {
  ORDER_CONFIRMED: 'ORDER_CONFIRMED',
  DELIVERY_PREPARING: 'DELIVERY_PREPARING',
  MAKER_TTC_DELIVERY_CONFIRMED: 'MAKER_TTC_DELIVERY_CONFIRMED',
  TTC_SHIWO_DELIVERY_CONFIRMED: 'TTC_SHIWO_DELIVERY_CONFIRMED',
} as const;
export const DELIVERY_STEPS: SelectOption[] = [
  { value: DELIVERY_STATUS.ORDER_CONFIRMED, label: 'Order confirmed' },
  { value: DELIVERY_STATUS.DELIVERY_PREPARING, label: 'Delivery preparing' },
  { value: DELIVERY_STATUS.MAKER_TTC_DELIVERY_CONFIRMED, label: 'Maker→TTC delivery confirmed' },
  { value: DELIVERY_STATUS.TTC_SHIWO_DELIVERY_CONFIRMED, label: 'TTC→Shiwo delivery confirmed' },
];

export const CANCEL_STATUS = {
  NULL: null,
  SHIWO_REQUESTED: 'SHIWO_REQUESTED',
  TTC_REQUESTED: 'TTC_REQUESTED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
} as const;
export const CANCEL_STEPS: SelectOption[] = [
  { value: CANCEL_STATUS.NULL, label: '' },
  { value: CANCEL_STATUS.SHIWO_REQUESTED, label: 'SHIWO_REQUESTED' },
  { value: CANCEL_STATUS.TTC_REQUESTED, label: 'TTC_REQUESTED' },
  { value: CANCEL_STATUS.REJECTED, label: 'REJECTED' },
  { value: CANCEL_STATUS.CANCELLED, label: 'CANCELLED' },
];

export const FACTORIES = {
  KOBE: 'FAC01',
  KASHIMA: 'FAC02',
  FUNABASHI: 'FAC03',
} as const;
export const SCHEDULE_FACTORIES: ScheduleFactoryOption[] = [
  { value: FACTORIES.KOBE, label: 'kobe' },
  { value: FACTORIES.KASHIMA, label: 'kashima' },
  { value: FACTORIES.FUNABASHI, label: 'funabashi' },
];

export const ITEM_UNIT = {
  BAG: 'BAG',
  FCL: 'FCL',
} as const;

export const ORDER_TYPES = {
  REGULAR: 'REGULAR',
  ADDITIONAL: 'ADDITIONAL',
} as const;

export const MONTHS: string[] = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
